<template>
  <div class="my-item">
    <div class="photo"> 
      <template v-if="list && list.length">
        <Table :border="false" :columns="columns1" :data="list" :disabled-hover="false"> 
          <template slot-scope="{ row, index }" slot="banner">
            <div class="view" style="border: 10px solid transparent;">
              <div class="view-info" v-if="row.path">
                <div class="view-tool">
                  <Icon
                    type="ios-eye-outline"
                    size="30"
                    color="#fff"
                    @click.native="handleView(row.path)"
                    style="cursor:pointer"
                  ></Icon>
                </div>
              </div>
              <img :src="row.path" v-if="row.path" />
              <img src="@/assets/img/empty.png" v-else />
            </div>
          </template> 
          <template slot-scope="{ row, index }" slot="showIndex">{{row.showIndex}}</template>
          <template slot-scope="{ row, index }" slot="isShow">
            <iSwitch :value="row.isShow" size="large" @on-change="changeSwitch($event, row)">
              <span slot="open">开启</span>
              <span slot="close">关闭</span>
            </iSwitch> 
          </template>
          <template slot-scope="{ row, index }" slot="action"> 
            <span style="color: #1890ff;cursor: pointer;" @click="showEdit(row)">编辑</span>
            <span style="display: inline-block;padding: 0 5px;">|</span>
            <Poptip confirm title="确认是否删除?" @on-ok="delItem(row)" :transfer="true">
              <span style="color: #f00;cursor: pointer;">删除</span>
            </Poptip>
          </template>
        </Table>
      </template>
      <div class="u-empty" v-else>暂无数据</div>
    </div>

    <iModal
      title="图片查看"
      cancel-text
      v-model="viewFlag"
      class-name="vertical-center-modal"
      :mask-closable="true"
      width="650"
      :styles="{top: '150px'}"
    >
      <img :src="viewUrl" alt="素材图片" style="width:600px;" />
    </iModal>

    <addPhoto :show="add" :typeId="2" :title="'添加影音图集'" @close="hideAdd()" @finish="init()" />
    <editPhoto
      :show="editShow"
      :typeId="2"
      :title="'编辑影音图集'"
      :info="editInfo"
      @close="hideEdit()"
      @finish="init()"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import addPhoto from "./add-photo.vue";
import editPhoto from "./edit-photo.vue";
export default {
  name: "photo-group",
  data() {
    return {
      add: false,
      list: null,
      pageSize: 16,
      pageIndex: 1,
      totalCount: 0,
      viewFlag: false,
      editShow: false,
      editInfo: null,
      viewUrl: "",
      loading: false,

      columns1: [
        {
          title: "banner",
          key: "banner",
          slot: "banner"
        },
        {
          title: "排序",
          slot: "showIndex",
          key: "showIndex",
          align: "center"
        },
        {
          title: "显示",
          slot: "isShow",
          key: "show",
          align: "center"
        },
        // {
        //   title: "加入时间",
        //   slot: "inTime",
        //   align: "center"
        // },
        {
          title: "操作",
          slot: "action",
          align: "center"
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany"
    }),
    option() {
      return { compId: this.company.id, type: 2 };
    }
  },
  components: {
    addPhoto,
    editPhoto
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getBanner: "bannerModule/getBanner",
      addBanner: "bannerModule/addBanner",
      delBanner: "bannerModule/delBanner",
      editBanner: "bannerModule/editBanner"
    }),
    handleView(data) {
      this.viewFlag = true;
      this.viewUrl = data;
    },
    async delItem(item) {
      let result = await this.delBanner(item.id);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
    async edit(item) {
      const req = {
        Id: item.id,
        SetValues: { IsShow: !item.isShow }
      };
      let result = await this.editBanner(req);
      if (result.successed) {
        this.$Message.success("修改成功");
        this.init();
      } else {
        this.$Message.error("修改失败，请重新尝试");
      }
    },
    showAdd() {
      this.add = true;
    },
    hideAdd() {
      this.add = false;
    },
    showEdit(data) {
      this.editInfo = data;
      this.editShow = true;
    },
    hideEdit() {
      this.editInfo = null;
      this.editShow = false;
    },
    async init() {
      this.loading = true;
      setTimeout(c => {
        this.loading = false;
      }, 5000);
      let data = await this.getBanner(this.option).catch(e => {
        this.loading = false;
      });
      if (data && data.length) {
        data.sort((a, b) => {
          return a.showIndex - b.showIndex;
        });
        this.list = data;
      }
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
    },
    changeSwitch(e, data) {
      this.edit(data);
    }
  }
};
</script>

<style lang="scss" scoped>
.my-item {
  min-width: 1000px;
  padding: 30px;
  min-height: 500px;
}
.photo {
  th {
    .ivu-table-cell {
      font-weight: bold;
    }
  }
  // padding: 18px;
  // min-height: 500px;
  background-color: #fff;
  &-img {
    width: 100%;
    padding-bottom: 66.666667%;
    display: inline-block;
    margin-bottom: 20px;
    position: relative;
    img {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      max-width: 100%;
      max-height: 100%;
      margin: auto;
      &:hover + .view-info {
        visibility: visible;
      }
    }
  }
}
.view {
  position: relative;
  padding-bottom: 66.666667%;
  img {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    margin: auto;
    max-width: 100%;
    max-height: 100%;
  }
  &:hover {
    .view-info {
      visibility: visible;
    }
  }
  &-info {
    visibility: hidden;
    width: 100%;
    height: 100%;
    padding: 0 22%;
    top: 0;
    right: 0;
    position: absolute;
    background-color: rgba(55, 55, 55, 0.6);
    font-weight: bold;
    display: flex;
    z-index: 2;
  }
  &-tool {
    flex: 1;
    align-items: center;
    justify-content: center;
    display: flex;
    .ivu-poptip {
      cursor: pointer;
      align-items: center;
      justify-content: center;
      display: flex;
      width: 50px;
      height: 50px;
      .ivu-poptip {
        width: 50px;
        height: 50px;
      }
    }
  }
}
</style>